//============================================================================
// Name        : partners.ts
// Purpose     : Implement partner/reseller page
// Created     : 2021-04-06
// Author      : Alireza Mohagheghi
// Copyright   : Copyright 2021 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";

class Partners {
    init() {
        const logoStatusBtn = $(".logo_status_btn");

        if ($("input[type=radio][id='partner_logo_status_reseller_and_senitron']:checked").val() == "reseller_and_senitron") {
            $(".logo_main_cont").removeClass("hide_element");
        }

        logoStatusBtn.on("click", (e) => {
            if ($(e.target).val() == "reseller_and_senitron") {
                $(".logo_main_cont").removeClass("hide_element");
            } else {
                $(".logo_main_cont").addClass("hide_element");
            }
        });
    }
}

export function LoadPage() {
    InitPage("partners", () => {
        const partners = new Partners();
        partners.init();
    });
}
